import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-sidebar-header',
  template: `
    <rt-heading class="sidebar--heading" variant="heading large-x">
      {{ title() }}
    </rt-heading>
  `,
  styleUrl: './sidebar-header.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent],
})
export class SidebarHeaderComponent {
  public title = input.required<string>();
}
